import React, { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import styles from "./Contact.module.scss";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import contactLang from "../../i18n/contact";
import { ChevronRight } from "react-bootstrap-icons";
import classNames from "classnames";
import { postRequest } from "../../actions/requests";
import { ToastContainer, toast } from "react-toastify";
import useBeforeunload from "hooks/useBeforeunload";
import Cookies from "js-cookie";

const ContactForm = React.forwardRef(({ onClick, children, survey }, ref) => {
  const { query, push, locale } = useRouter();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [setIsUnload] = useBeforeunload();
  const refValue = useRef({
    name: "",
    phone: "",
    email: "",
    company: "",
    content: "",
  });

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.validateForm();
    }
  }, [locale]);

  const onSubmit = async (values, actions) => {
    const token = await executeRecaptcha("contact");
    values.lang_id = locale === "vi" ? 1 : 2;
    if (values.content === "") values.content = undefined;
    if (values.company === "") values.company = undefined;
    if (token) {
      let msg =
        locale === "vi" ? "Tạo yêu cầu thành công" : "Create request success";
      values.type = query.service_id ? 2 : 1;
      const data = { ...values, data_submit: survey };
      postRequest(data)
        .then((res) => {
          toast.success(msg, {
            position: "top-center",
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
            newestOnTop: true,
          });
          actions.resetForm({
            values: {
              name: "",
              phone: "",
              email: "",
              content: "",
              company: "",
            },
          });
          if (onClick) {
            onClick();
          } else {
            setTimeout(() => {
              push("/");
            }, 2000);
          }
          setIsUnload(false);
          Cookies.remove("isLeave");
        })
        .catch((error) => {
          console.log("error", error);
          // toast.error("", {
          //     position: "top-center",
          //     autoClose: 3000,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     newestOnTop: true
          // })
        });
    }
  };

  const handleChangeValues = (e) => {
    const values = e.target.value;
    const name = e.target.name;
    Cookies.set("isLeave", true);
    setIsUnload(true);
    if (values) {
      refValue.current = { ...refValue.current, [name]: values };
      Cookies.set(name, values, { expires: 30 * 12 * 5 });
    }
  };

  const handleBlur = (e) => {
    const values = e.target.defaultValue;
    const name = e.target.name;

    if (!values) {
      Cookies.set(
        { ...refValue.current, [name]: refValue.current[name] },
        { expires: 30 * 12 * 5 }
      );
    }
  };

  return (
    <>
      <ToastContainer />
      <Formik
        innerRef={ref}
        validateOnMount={true}
        onSubmit={onSubmit}
        validationSchema={Yup.object().shape({
          name: Yup.string().trim().required(
            locale === "vi" ? "Trường bắt buộc" : "Required field"
          ),
          phone: Yup.string().trim().required(
            locale === "vi" ? "Trường bắt buộc" : "Required field"
          ),
          email: Yup.string().trim()
            .email(
              locale === "vi" ? "Không đúng định dạng email" : "Invalid email"
            )
            .required(locale === "vi" ? "Trường bắt buộc" : "Required field"),
        })}
        name="contact_form"
        initialValues={{
          name: Cookies.get("name") || undefined,
          phone: Cookies.get("phone") || undefined,
          email: Cookies.get("email") || undefined,
          company: Cookies.get("company") || undefined,
          content: query?.msg ? query.msg : Cookies.get("content"),
          service_id: query.service_id * 1,
          type: query.service_id ? 2 : 1,
        }}
        enableReinitialize={true}
      >
        {({ values, submitForm, errors, touched }) => (
          <div className="d-flex flex-wrap align-items-end">
            <div
              className={classNames(
                "col-12 col-lg-10 py-4",
                styles.contactForm
              )}
            >
              {children || null}
              {/* <div className="col-12 col-lg-6">
                            <HtmlRender>
                                {contactLang.paragraph[locale]}
                            </HtmlRender>
                            <p className="mb-0"><Envelope className="mr-2" /> <a href={`mailto: ${contactLang.email[locale]}`}>{contactLang.email[locale]}</a></p>
                            <p><Phone className="mr-2" /> <a href={`tel: ${contactLang.phone[locale]}`} className="cursor-pointer text-dark-blue">{contactLang.phone[locale]}</a></p>
                        </div> */}
              <Form
                name="contact-form"
                className="d-flex flex-wrap"
                onBlur={handleBlur}
                onChange={handleChangeValues}
              >
                <div className="col-12 col-lg-4">
                  <div className="mt-2">
                    <Field name="type" type="hidden" />
                    <Field name="service_id" type="hidden" />
                    <Field
                      name="name"
                      className="w-100 py-1 px-3"
                      placeholder={contactLang.form_name[locale]}
                    />
                    {errors.name && touched.name ? (
                      <div className="error-text">{errors.name}</div>
                    ) : null}
                  </div>
                  <div className="mt-2">
                    <Field
                      name="phone"
                      className="w-100 py-1 px-3"
                      placeholder={contactLang.form_phone[locale]}
                    />
                    {errors.phone && touched.phone ? (
                      <div className="error-text">{errors.phone}</div>
                    ) : null}
                  </div>
                  <div className="mt-2">
                    <Field
                      name="email"
                      className="w-100 py-1 px-3"
                      placeholder={contactLang.form_email[locale]}
                    />
                    {errors.email && touched.email ? (
                      <div className="error-text">{errors.email}</div>
                    ) : null}
                  </div>
                  <div className="mt-2">
                    <Field
                      name="company"
                      className="w-100 py-1 px-3"
                      placeholder={contactLang.form_company[locale]}
                    />
                  </div>
                </div>
                <div className="mt-2 col-12 col-lg-7">
                  <Field
                    as="textarea"
                    name="content"
                    className="px-3 py-1 w-100 h-100"
                    placeholder={contactLang.form_message[locale]}
                  />
                </div>
              </Form>
            </div>
            <div className="col-6 col-md-3 mx-auto px-0 px-lg-3 col-lg-2 mt-lg-0 mt-3 mb-4 mb-md-0">
              <div
                onClick={() => submitForm()}
                className="w-auto btn btn-outline-dark custom d-flex align-items-center justify-content-between"
              >
                <span>{contactLang.send[locale]}</span>
                <div className="svg-wrapper">
                  <ChevronRight />
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
});

export default ContactForm;
